<template>
  <MetricsSummary
    v-if="!loading"
    split-apart
    :summaries="summaries"
    :label-width="totalsLabelWidth"
    show-download
    new-version
    :download-png-file-name="getFileName"
  />
  <SummarySkeletonLoader
    v-else-if="numberOfSummarySkeletons"
    :is-loading="loading"
    split-apart
    new-version
    :number-of-metrics="numberOfSummarySkeletons"
    class="skeleton-loader"
  />
</template>

<script setup>
import SummarySkeletonLoader from '@/components/shared/SkeletonLoaders/SummarySkeletonLoader.vue';
import MetricsSummary from '@/components/shared/MetricsSummary.vue';
import { useRoute } from 'vue-router';
import { toFileNameFormat } from '@/helpers/date';

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  summaries: {
    type: Array,
    default: () => [],
  },
  numberOfSummarySkeletons: {
    type: Number,
    default: 0,
  },
  totalsLabelWidth: {
    type: String,
    default: '0',
  },
  projectName: {
    type: String,
    default: '',
  },
  dateRange: {
    type: Object,
    default: () => ({}),
  },
});

const route = useRoute();

const getFileName = (id) => {
  const dateString = props.dateRange?.from && props.dateRange?.to
    ? `-${toFileNameFormat(props.dateRange.from)}-${toFileNameFormat(props.dateRange.to)}`
    : '';

  return `${props.projectName}-${route.name}-${id}${dateString}`;
};
</script>

<style lang="less" scoped>
.v-application .skeleton-loader {
  margin: 0 !important;
}
</style>
